import { render, staticRenderFns } from "./NetGsmExtensionMapping.vue?vue&type=template&id=7b12fbac"
import script from "./NetGsmExtensionMapping.vue?vue&type=script&lang=js"
export * from "./NetGsmExtensionMapping.vue?vue&type=script&lang=js"
import style0 from "./NetGsmExtensionMapping.vue?vue&type=style&index=0&id=7b12fbac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports